import { render, staticRenderFns } from "./AmendLoginpwd.vue?vue&type=template&id=0479765e"
import script from "./AmendLoginpwd.vue?vue&type=script&lang=js"
export * from "./AmendLoginpwd.vue?vue&type=script&lang=js"
import style0 from "./AmendLoginpwd.vue?vue&type=style&index=0&id=0479765e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports